<template>
  <v-card dense style="height: 60vh;">
    <v-card-text>
      <v-row>
    <v-tabs  hide-slider active-class="elevation-10" grow>
      <v-tab>Add new users</v-tab>
      <v-tab>Add existing users</v-tab>
      <v-tab-item>
        <EmailForm
          :disabled="inviting"
          ref="emailForm"
          v-on:submit-form="onAddUsersManually"
          button-text="Add"
        />
      </v-tab-item>
      <v-tab-item>
        <ItemListInfo
          dense
          :headers="existingUsersHeaders"
          :has-search="true"
          :has-action="true"
          :has-add-action="true"
          :items="usersToInvite"
          :loading="inviting"
          @on-click-add="onAddExistingUser"
          init-sort="email"
        />
      </v-tab-item>
    </v-tabs>
      </v-row>
    <hr>
    <v-toolbar flat>
      <v-toolbar-title>Users to invite</v-toolbar-title>
    </v-toolbar>
    <v-chip :disabled="invite.loading" close @click:close="removeEmailFromInviteList(index)" class="ma-1" v-for="(invite, index) in emailsToInvite" :key="index">
      <v-progress-circular v-if="invite.loading" indeterminate color="loading"/>
      {{invite.email}}</v-chip>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn :disabled="inviting" class="secondary" @click="onClickClose">cancel</v-btn>
      <v-btn class="primary" :disabled="emailsToInvite.length === 0 || inviting" @click="onClickInvite">
        Invite
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import EmailForm from '../EmailForm'
import ItemListInfo from '../ItemListInfo'
import bulkOperation from '../../mixins/bulkOperation'

export default {
  name: 'InviteUsersComponent',
  mixins: [bulkOperation],
  components: {
    EmailForm,
    ItemListInfo
  },
  props: ['onClose'],
  data: () => ({
    emailsToInvite: [],
    inviting: false,
    existingUsersHeaders: [
      {
        text: 'Email',
        align: 'left',
        dense: true,
        value: 'email'
      }
    ]
  }),
  methods: {
    onClickAddNewUser: function () {
      this.inviteModal = true
    },

    onClickClose: function () {
      this.$refs.emailForm.resetData()
      this.emailsToInvite = []
      this.onClose()
    },

    onClickInvite: function () {
      let invitationPromises = this.emailsToInvite.map(invite => this.$store.dispatch('customer/createInvitation', { email: invite.email, subscriptionIds: [this.subscriptionId] }))
      this.executeBulkOperation(invitationPromises)
    },

    beforeBulk: function () {
      this.beforeInvite()
    },

    handleBulkError: function (error) {
      console.error(error)
      this.$store.commit('setErrorMessages', error)
    },

    handleBulkSuccess: function (successfulInvites) {
      this.clearSuccessfullInvites(successfulInvites)
      this.showSuccessMessage(successfulInvites)
    },

    afterBulk: function () {
      this.afterInvite()
    },

    showSuccessMessage: function (invites) {
      let emails = ''
      for (let invite of invites) {
        emails += invite.email + ', '
      }
      emails = emails.substr(0, emails.length - 2)
      this.$store.commit('setSuccessMessage', 'Invites to ' + invites[0].subscriptions[0].unit.alias + ' has been successfully created for: ' + emails)
    },

    clearSuccessfullInvites: function (invites) {
      for (let x of invites) {
        const isMatchingEmail = (invite) => invite.email === x.email
        let index = this.emailsToInvite.findIndex(isMatchingEmail)
        if (index >= 0) {
          this.emailsToInvite.splice(index, 1)
        }
      }
    },

    beforeInvite: function () {
      this.inviting = true
      for (let invite of this.emailsToInvite) {
        invite.loading = true
      }
    },

    afterInvite: function () {
      this.inviting = false
      if (this.emailsToInvite.length === 0) {
        this.onClickClose()
      } else {
        for (let invite of this.emailsToInvite) {
          invite.loading = false
        }
      }
    },

    onAddUsersManually: function (formData) {
      let emailString = formData.email.replace(/\s+/g, '')
      let emailList = emailString.split(',')
      for (let index in emailList) {
        if (!this.emailsToInvite.some(e => e.email === emailList[index])) {
          this.emailsToInvite.unshift({ loading: false, email: emailList[index] })
        }
      }
      this.$refs.emailForm.resetData()
    },

    onAddExistingUser: function (user) {
      let email = user.email
      if (!this.emailsToInvite.some(e => e.email === email)) {
        this.emailsToInvite.unshift({ loading: false, email: email })
      }
    },

    removeEmailFromInviteList: function (index) {
      this.emailsToInvite.splice(index, 1)
    }
  },

  computed: {
    subscriptionId: function () {
      return this.$store.state.subscription.currentSubscription.data.id
    },
    usersNotConnectedToSubscription: function () {
      return this.$store.getters['subscription/UsersNotConnectedToSubscription']
    },
    usersToInvite () {
      if (this.emailsToInvite.length === 0) {
        return this.usersNotConnectedToSubscription
      } else {
        let difference = JSON.parse(JSON.stringify(this.usersNotConnectedToSubscription))
        let addedUsers = this.emailsToInvite
        for (let i in addedUsers) {
          let index = difference.findIndex(function (item) {
            return item.email === addedUsers[i].email
          })
          if (index >= 0) {
            difference.splice(index, 1)
          }
        }
        return difference
      }
    }
  }
}
</script>

<style scoped>

</style>
